const version ='1.6.5'
export default version
console.log(version)
